import React, { Component } from 'react';
import * as Request from '../../service/data-info-chart/requestsUtil';
import view from '../../resources/images/estrategas/tools/view.svg';
import { Input, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';


class Save extends Component {

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.viewClaims = this.viewClaims.bind(this);
    this.writeClaims = this.writeClaims.bind(this);
    this.state = {
      modal: false,
      text: '',
      date: '',
      data: [],
    };
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
    this.viewClaims()
  }

  viewClaims() {
    Request.getFetch(this.props.url)
      .then((data) => {
        this.setState({ data: data }, function stateUpdateComplete(){
          this.writeClaims();
        }.bind(this));
      });
  }

  writeClaims(){
    let claimsContent=this.state.data.map(resp=>{
      return <div className='mb-4'><b>{resp.date}</b><div className='mb-3'>{resp.claim}</div></div>;
    });
    return claimsContent
  }

  render() {


    return (<div>
        <div className='quality-edit'>
          <img src={view} title="Ver" alt=" " onClick={this.toggle}/>
        </div>
        <Modal className='modal-large' isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader className='header-modal'
                       toggle={this.toggle}>Periodo {this.props.dateModal}</ModalHeader>
          <ModalBody>
            <div className='container'>
              <p className='container-fluid'>Reclamaciones unidad {this.props.place.name}:</p>
              <div className='claim-viewer'>
                {this.writeClaims()}
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggle}>Aceptar</Button>{' '}
          </ModalFooter>
        </Modal>
      </div>

    );
  }
}

export default Save;



// WEBPACK FOOTER //
// ./src/components/buttons/viewModal.js